import {styled} from '@core-ui/react-stitch';

const PaginatorWrapper = styled.div(({ isBRRedesignEnabled }) => ({
  ...isBRRedesignEnabled && {
    padding: '1.78rem 0 1.28rem',
    '@media (max-width: 1024px)':{
      padding: '0.781rem 0 1.28rem',
    },
  },
}));

export default PaginatorWrapper;
